module.exports = __webpack_public_path__ + "img/datamango-logo-rgb-480px.248a88ab.png";